import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router'
import IconSVG from 'svg-inline-react'

import style from './style.styl'

import backButtonSrc from '!svg-inline?removeTags=true!images/icons/caret-icon.svg'

const HeaderBackButton = function HeaderBackButton({ target = "", to, text, query }) {
  return (
    <Link target={target} to={{ pathname: to,query }}
      className={style.HeaderBackButton}>
      <IconSVG className="back" src={backButtonSrc} />
      {text}
    </Link>
  )
}

HeaderBackButton.propTypes = {
  to: PropTypes.string.isRequired,
  query: PropTypes.object,
  text: PropTypes.string.isRequired
}

export default HeaderBackButton



// WEBPACK FOOTER //
// ./src/scripts/components/nav/Header/HeaderBackButton/index.js